import store from '@/store';
import { Trans } from "@/plugins/trans";

export const authenticationGuard = (to, _from, next) => {
    // Already authenticated in this session
    if (store.state.IsAuthenticated) {
        return next();
    }

    const lang = (to.params.lang && Trans.isLangSupported(to.params.lang))
        ? to.params.lang
        : Trans.getUserSupportedLang();

    const token = localStorage.getItem("authToken");
    if (!token) {
        return next({ name: "SignIn", params: { lang } });
    }

    // Try to restore auth from a persisted token
    store.dispatch("SetAuthToken", token)
        .then(() => next())
        .catch(() => {
            localStorage.removeItem("authToken");
            next({ name: "SignIn", params: { lang } });
        });
};
